"use client";

import React from "react";
import Page from "@/components/ui/page";
import Header from "@/components/Header";
import CallToAction from "@/components/CallToAction";
import { TeamMemberProfile } from "@/components/TeamMember";
import { TeamMemberPosts } from "@/components/TeamMemberPosts";
import { useTina } from "@/utils";
import { findTeamMemberInAbout } from "@/lib/team-members";
import type { TeamMemberPost } from "@/lib/team-member-posts";

export default function TeamMemberPage({
  aboutData,
  member,
  slug,
  posts,
}: {
  aboutData: any;
  member: any;
  slug: string;
  posts: TeamMemberPost[];
}) {
  const { data } = useTina({
    query: aboutData.query,
    variables: aboutData.variables,
    data: aboutData.data,
  });

  const about = data?.about;
  const memberSource = findTeamMemberInAbout(about, slug);
  const liveMember = memberSource?.member || member;

  return (
    <Page
      defaultTinaField={about}
      seo={{
        title: liveMember?.name || member?.name,
        description: liveMember?.description || liveMember?.role,
        image: liveMember?.image,
      } as any}
      pagePath={`/team/${slug}`}
      titleFallback={liveMember?.name || member?.name || "Team Member"}
    >
      <Header
        backgroundVariant="pixels-subtle"
        wrapperClassName="!pb-12 lg:!pb-16"
        className="w-full gap-0"
      >
        <TeamMemberProfile
          member={liveMember}
          variant="header"
        />
      </Header>
      <TeamMemberPosts memberName={liveMember?.name} posts={posts} />
      <CallToAction
        variant="center"
        backgroundVariant="dots"
        globalCtaType="teamCta"
      />
    </Page>
  );
}
